<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="workUnits"
      :table-select="false"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="单元编号">
            <el-input v-model.trim="filter.workUnitNo" placeholder="请输入单元编号" clearable />
          </el-form-item>
          <el-form-item label="单元名称">
            <el-input v-model.trim="filter.workUnitName" placeholder="请输入单元名称" clearable />
          </el-form-item>
          <el-form-item label="生产中心">
            <el-input v-model.trim="filter.workCenterName" placeholder="请输入生产中心名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <WorkUnitEdit ref="workUnitEdit" @save-success="loadData"></WorkUnitEdit>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import WorkUnitEdit from "./WorkUnitEdit";
export default {
  components: { viewTable, WorkUnitEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(679),
        editAuth: this.$auth(680),
        delAuth: this.$auth(681),
      },
      filter: {},
      columnsProperty: [
        {
          tooltip: true,
          key: "workUnitNo",
          width: 100,
          align: "center",
        },
        {
          key: "workUnitName",
          minWidth: 150,
          tooltip: true,
        },
        {
          key: "workCenterName",
          minWidth: 150,
          tooltip: true,
        },
        {
          tooltip: true,
          key: "creatorName",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "createTime",
          width: 160,
          align: "center",
        },
        {
          key: "action",
          align: "center",
          width: 140,
          slot: "action",
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    // 新增、编辑
    addEditHandle(row) {
      this.$refs.workUnitEdit.open(row);
    },

    // 加载数据
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },

    // 删除
    deleteHandle(row) {
      this.$http.delete("basic", "workUnits", row.pkId).then((resp) => {
        if (resp.success) {
          this.loadData();
          this.$message.success("删除成功");
        }
      });
    },

    resetHandle(filter) {
      this.filter = filter;
    },
  },
};
</script>
